import { useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

// Fetches editable website photos (hero, about, bookings, gallery) from the
// backend so the shop owner can manage them from the admin dashboard.
export function useSiteContent() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/site-content`)
      .then((res) => {
        if (active) setContent(res.data);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return content;
}
